module.exports = __webpack_public_path__ + "static/media/3H.700bdcc3.svg";